import React from "react";
import "./Timeline.css";

const Timeline = () => {
  return (
    <div className="timeline_crown" id="Roadmap">
      <div className="text-center timeline-new">
        <h1 className="rd_main_h">$PIKU ROADMAP</h1>
        <p className="para_rd">
          The $PIKU Roadmap paves the way for innovation, community growth, and
          global dominance in the crypto space.
        </p>
      </div>

      <section class="design-section" id="Roadmap">
        <div class="timeline">
          <div class="timeline-empty"></div>
          <div class="timeline-middle">
            <div class="timeline-circle"> </div>
          </div>

          <div class="timeline-component timeline-content">
            <h1 style={{ fontSize: "30px" }}>Phase 1: Presale - Pre-selling PIKU Coin</h1>
          
            <li className="fs-5">Launch and pre-sell piku Coin (PIKUCOIN), the primary currency in the piku ecosystem.</li>
            <li className="fs-5">Implement a Presale campaign to introduce PIKUCOIN to the community.</li>
            <li className="fs-5">Buyers can acquire PIKUCOIN at a preferential price before it is listed on exchanges.</li>
            <li className="fs-5">PIKUCOIN can be used to exchange for other coins after listing.</li>
          </div>
          <div class="timeline-component timeline-content">
            <h1 style={{ fontSize: "30px" }}>Phase 2: Horse Racing Game</h1>
            
            <li className="fs-5">Develop and launch the horse racing game on the blockchain platform.</li>
            <li className="fs-5">Players participate in horse races to earn PIKUCOIN.</li>
            <li className="fs-5">Earned PIKUCOIN can be used to play other games or exchanged for other coins.</li>
            <li className="fs-5">Integrate blockchain technology to ensure transparency and fairness in the game.</li>

            <ul className="para-timeline"></ul>
          </div>

          <div class="timeline-middle">
            <div class="timeline-circle"> </div>
          </div>

          <div class="timeline-empty"> </div>
          <div class="timeline-empty"></div>

          <div class="timeline-middle">
            <div class="timeline-circle"></div>
          </div>

          <div class=" timeline-component timeline-content">
            <h1 style={{ fontSize: "30px" }}>Phase 3: Checkered Flag Game</h1>
           
            <li className="fs-5">Expand the gaming ecosystem with the tic-tac-toe game.</li>
            <li className="fs-5">A simple yet engaging tic-tac-toe game suitable for all audiences.</li>
            <li className="fs-5">Players use PIKUCOIN to participate and earn rewards.</li>

            <ul className="para-timeline"></ul>
          </div>
          <div class=" timeline-component timeline-content">
            <h1 style={{ fontSize: "30px" }}>Phase 4: Chess Game</h1>
        
            <li className="fs-5">Launch a chess game to increase diversity in the piku ecosystem.</li>
            <li className="fs-5">Integrate online chess match features.</li>
            <li className="fs-5">Use PIKUCOIN for betting, tournament participation, and rewards.</li>
            <li className="fs-5">Support both casual and professional gameplay modes.</li>

            <ul className="para-timeline"></ul>
          </div>

    

          <div class="timeline-middle">
            <div class="timeline-circle"> </div>
          </div>

          <div class="timeline-empty"> </div>
          <div class="timeline-empty"></div>

          <div class="timeline-middle">
            <div class="timeline-circle"></div>
          </div>
          

         
        </div>
      </section>
    </div>
  );
};

export default Timeline;
